import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, failed
  const [message, setMessage] = useState('Verifying your payment...');

  useEffect(() => {
    const verifyPayment = async () => {
      const reference = searchParams.get('reference');
      
      if (!reference) {
        setStatus('failed');
        setMessage('Payment reference not found');
        return;
      }

      try {
        const token = localStorage.getItem('token');
        
        console.log('Verifying payment with reference:', reference);
        
        const response = await axios.get(
          `${API}/payments/verify/${reference}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }
        );

        console.log('Payment verification response:', response.data);

        if (response.data.status === 'successful') {
          setStatus('success');
          setMessage('Payment successful! Redirecting...');
          
          // Redirect to dashboard after 2 seconds with full page reload
          setTimeout(() => {
            window.location.href = '/dashboard';
          }, 2000);
        } else {
          setStatus('failed');
          setMessage('Payment verification failed');
        }
      } catch (error) {
        console.error('Payment verification error:', error);
        setStatus('failed');
        setMessage(error.response?.data?.detail || 'Failed to verify payment');
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="glass max-w-md w-full rounded-sm p-8 text-center">
        {status === 'verifying' && (
          <>
            <Loader className="w-16 h-16 text-primary mx-auto mb-4 animate-spin" />
            <h2 className="text-2xl font-heading font-bold mb-2">Verifying Payment</h2>
            <p className="text-textSecondary">{message}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-2xl font-heading font-bold mb-2 text-green-500">Payment Successful!</h2>
            <p className="text-textSecondary mb-4">{message}</p>
            <div className="w-full bg-primary/20 rounded-full h-2 overflow-hidden">
              <div className="bg-primary h-full animate-progress"></div>
            </div>
          </>
        )}

        {status === 'failed' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-heading font-bold mb-2 text-red-500">Payment Failed</h2>
            <p className="text-textSecondary mb-6">{message}</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="bg-primary hover:bg-primaryHover text-white rounded-sm font-bold px-6 py-3 transition-colors"
            >
              Back to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentCallback;
